module.exports = __webpack_public_path__ + "static/img/2.014db34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/2.png
// module id = cqIS
// module chunks = 0